export const KNOWLEDGE_CENTER_URL =
  'https://support.evisort.com/hc/en-us/articles/4434176568599-Admin-How-To-Bulk-Import-Document-Data';

export const EVISORT_URL_REGEXP =
  /^(https?:\/\/)?([\w-]+\.)*evisort\.com(\/.*)?$/;
